export default {
  GQL_EP: process.env.NEXT_PUBLIC_GRAPHQL_EP,
  GQL_AUTH_EP: process.env.NEXT_PUBLIC_GRAPHQL_AUTH_EP,
  IMAGES_BASE_URL: process.env.NEXT_PUBLIC_LISTINGS_IMAGES_BASE_URL,
  CDN2_IMAGES_BASE_URL: process.env.NEXT_PUBLIC_CDN2_IMAGES_BASE_URL,
  IMAGES_CDN_BASE_URL: process.env.NEXT_PUBLIC_IMAGES_CDN_BASE_URL,
  ICONS_BASE_URL: process.env.NEXT_PUBLIC_ICONS_BASE_URL,
  ASSETS_BASE_URL:
    process.env.NEXT_PUBLIC_ASSETS_BASE_URL || "https://assets.aqar.fm/",
  PARTNERS_BASE_URL: process.env.NEXT_PUBLIC_PARTNERS_LOGOS_BASE_URL,
  GM_API_KEY: process.env.NEXT_PUBLIC_GM_API_KEY,
  GM_SET_API_KEY: process.env.NEXT_PUBLIC_GM_SET_API_KEY,
  LISTINGS_PAGE_SIZE: 20,
  MAP_PAGE_SIZE: 50,
  USER_FEES_PAGE_SIZE: 20,
  LISTINGS_DEFAULT_SORTER: { create_time: "desc", has_img: "desc" },
  REGION_HEADER_SIZE: 3,
  NUMBER_PRELOADED_IMAGES: 4,
  NUMBER_PRELOADED_LISTING_IMAGES: 2,
  NUMBER_RELATED_LISTINGS: 3,
  SOURCE_HEADER: "Web",
  BUILD_TARGET: process.env.NEXT_PUBLIC_BUILD_TARGET,
  AQAR_WEB: process.env.NEXT_PUBLIC_AQAR_WEB_EP,
  AQAR_WEB_EP: process.env.NEXT_PUBLIC_AQAR_WEB_EP?.includes("sa")
    ? "https://sa.aqar.fm"
    : "https://dev-v3.aqar.fm",
  GA_TRACKING_ID: process.env.NEXT_PUBLIC_GA_TRACKING_ID,
  HOST_URL: process.env.NEXT_PUBLIC_HOST_URL,
  APP_LINK: process.env.NEXT_PUBLIC_APP_LINK,
  GGL_TAGS: process.env.NEXT_PUBLIC_APP_GGL_TAGS,
  APPLE_PAY_VERSION_NUMBER: 5,
  GA4_TRACKING_ID: process.env.NEXT_PUBLIC_GA4_TRACKING_ID,
  INTERCOM_APP_ID: process.env.NEXT_PUBLIC_INTERCOM_APP_ID,
  aws_img: "https://s3-eu-west-1.amazonaws.com/aqar",
};

export const PARAM_FILTER = {
  published: 1,
  keyword: 1,
  start: 1,
  end: "1",
};
export const PLUS_FILTERS = {
  verified_owner: 1,
  direct_from_owners: 1,
  unverified_owner: 1,
  unique_listing: 1,
  create_time: 1,
};
export const RED_CDN = process.env.NEXT_PUBLIC_IMAGES_CDN_BASE_URL + "projects";
export const THUMBOR_CDN =
  process.env.NEXT_PUBLIC_LISTINGS_IMAGES_BASE_URL + "webp/{size}/props/{file}";
